import { useMemo, useState } from 'react';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Table, Row, Cell, Pagination } from '@dsi/react-eds';
import styles from './UploadResultsTable.module.css';

interface UploadResult {
  email?: string;
  role?: string;
  password?: string;
  error?: string;
  row?: number;
  username?: string;
}

interface UploadResultsTableProps {
  results: UploadResult[];
}

const UploadResultsTable: React.FC<UploadResultsTableProps> = ({ results }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('10');

  const columns = [
    {
      attribute: 'email',
      title: 'Email Address',
      width: '30%'
    },
    {
      attribute: 'role',
      title: 'Role',
      width: '15%'
    },
    {
      attribute: 'password',
      title: 'Temporary Password',
      width: '25%'
    },
    {
      title: 'Status',
      width: '30%'
    }
  ];

  // Calculate pagination
  const numPages = Math.max(1, Math.ceil(results.length / parseInt(pageSize)));
  const pagedResults = useMemo(() => {
    const start = (page - 1) * parseInt(pageSize);
    return results.slice(start, start + parseInt(pageSize));
  }, [results, page, pageSize]);

  const handlePageChange = (newPage: number) => setPage(newPage);
  const handlePageSizeChange = (size: string) => {
    setPageSize(size);
    setPage(1);
  };

  if (results.length === 0) {
    return null;
  }

  return (
    <div className={styles.tableContainer}>
      <ReactEDSWrapper component={Table} columns={columns}>
        {pagedResults.map((result, idx) => (
          <ReactEDSWrapper key={idx} component={Row}>
            <ReactEDSWrapper component={Cell}>{result.email || result.username || 'N/A'}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>{result.role || 'N/A'}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>{result.password || '-'}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>{result.error || '✅ Created'}</ReactEDSWrapper>
          </ReactEDSWrapper>
        ))}
      </ReactEDSWrapper>

      <ReactEDSWrapper
        component={Pagination}
        numPages={numPages}
        selectedPage={page}
        onPaginationChangePage={handlePageChange}
        optionsList={[
          { value: '5', label: '5', active: pageSize === '5' },
          { value: '10', label: '10', active: pageSize === '10' },
          { value: '20', label: '20', active: pageSize === '20' },
          { value: '50', label: '50', active: pageSize === '50' }
        ]}
        onPaginationChangeSelect={handlePageSizeChange}
        withActions
      />
    </div>
  );
};

export default UploadResultsTable;
